import React, { useState } from "react";

import { get } from "lodash";
import { Row } from "reactstrap";
import InvestmentOverviewBase from "./InvestmentOverviewBase";
import { useEffect } from "react";
import moment from "moment";


export default function InvestmentOverviewMain(props) {
  const { assetDetails } = props;
  const { Coupons } = props;
  const { realisedCouponsSum } = props;
  const [portfolio, setPortfolio] = useState([]);

  useEffect(() => {
    let pf = [];
    if (props.productType !== "bonds") {
      pf = [
        {
          title: "Current Value",
          value: get(props.portfolioValue, "data.pfStats.mtm", 0)
            .oroNumber(2, true),
        },
        {
          title: "Amount Invested",
          value: get(props.portfolioValue, "data.pfStats.userInvestedAmnt", 0).oroNumber(2,true  ) ?
          get(props.portfolioValue, "data.pfStats.userInvestedAmnt", 0).oroNumber(2,true  ) : "--"
        },
        {
          title: "Units",
          value: get(props.portfolioValue, "data.pfStats.units", 0),
        },
        {
          title: "Absolute Returns",
          value:Math.round(
            get(props?.portfolioValue, "data.absoluteReturns", 0) * 100
          ) / 100 + "%" ? Math.round(
            get(props?.portfolioValue, "data.absoluteReturns", 0) * 100
          ) / 100 + "%" : '--'
        },
        {
          title: "Maturity Date",
          value: moment(new Date(props.assetDetails?.maturityDate)).format("Do MMM YYYY"),
        },
      ];
    } else {
      pf = [
        {
          title: "Current Value",
          value: get(props.portfolioValue, "data.pfStats.mtm", 0).oroNumber(2, true),
        },
        {
          title: "Payouts",
          value: Coupons ? Coupons : "",
        },
        {
          title: "Amount Invested",
          value: get(props.portfolioValue, "data.pfStats.userInvestedAmnt", 0).oroNumber(2, true),
        },
        {
          title: "Units",
          value: get(props.portfolioValue, "data.pfStats.units", 0),
        },
        {
          title: "XIRR",
          value: get(props.portfolioValue, "data.userXirr", "")
        },
      ];
    }
    setPortfolio([...pf]);
  }, [props.portfolioValue, props.productType, props.assetDetails && props.assetDetails.maturityDate]);

  const style = {
    maxWidth: "1124px",
    marginTop: "2rem",
    marginBottom: "4rem",
  };
  const title = {
    fontSize: "28px",
    marginBottom: "1.5rem",
  };
  const main={
    position: "relative",
    textAlign: "center",
    gap:"5px",
  };
  const subtitle={
    position:"absolute",
    top:"4px",
    left: "13px",
    color:"#FFFF",
    fontSize: "20px"
  }
  const ribbon={
    padding:"0.4rem"
  }

  return (
    <Row
      className="mx-auto align-items-center justify-content-start w-100"
      style={style}
    >
      {portfolio.map((item, index) => (
        <InvestmentOverviewBase
          realisedCouponsSum={realisedCouponsSum}
          Coupons={Coupons}
          title={item.title}
          value={
            item.title === "XIRR"
              ? item.value
                ? item.value + "% p.a."
                : "NA"
              : item.value
          }
          isTotal={index === 0}
          last={index === portfolio.length - 1}
          closeYTMModal={props.closeYTMModal}
          showYTM={props.showYTM}
          setShowYTM={props.setShowYTM}
          assetDetails={assetDetails}
          openModal={props.openModal}
          productType={props.productType}
          isRedemptionAllowed={assetDetails?.isRedemptionAllowed}
          productName={assetDetails?.product}
        />
      ))}
    </Row>
  );
}
